var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 8.51074V12.3835H15.3818C15.1455 13.6289 14.4363 14.6835 13.3727 15.3926L16.6181 17.9108C18.509 16.1654 19.5999 13.6017 19.5999 10.5563C19.5999 9.84722 19.5363 9.16534 19.4181 8.51085L10 8.51074Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.39567 12.2324L3.66371 12.7927L1.07275 14.8109C2.7182 18.0745 6.09068 20.3291 9.99974 20.3291C12.6997 20.3291 14.9633 19.4382 16.6179 17.9109L13.3724 15.3927C12.4815 15.9927 11.3451 16.3564 9.99974 16.3564C7.39976 16.3564 5.19073 14.6019 4.39976 12.2382L4.39567 12.2324Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.07265 5.84717C0.390868 7.19257 0 8.71077 0 10.3289C0 11.9471 0.390868 13.4653 1.07265 14.8107C1.07265 14.8197 4.39998 12.2289 4.39998 12.2289C4.19998 11.6289 4.08177 10.9925 4.08177 10.3288C4.08177 9.6651 4.19998 9.02877 4.39998 8.42878L1.07265 5.84717Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.99995 4.31092C11.4727 4.31092 12.7818 4.81999 13.8272 5.80183L16.6908 2.93823C14.9545 1.32007 12.7 0.329102 9.99995 0.329102C6.09089 0.329102 2.7182 2.57455 1.07275 5.84729L4.39998 8.42911C5.19084 6.06545 7.39996 4.31092 9.99995 4.31092Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e11dc7d81791312201cc4423281404fd.svg";
export { ForwardRef as ReactComponent };